import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux/hooks";
import { selectedUser, verifyJwt } from "../authSlice";
import {
  generateSubscriptionAPIGTMEvent,
  pushGTMEvent,
} from "../../../shared/helpers/gtm";

const PublicRoute = ({ page }: { page: JSX.Element }) => {
  const { isAuthenticated, signup, identity } = useAppSelector(selectedUser);
  const dispatch = useAppDispatch();
  
  useEffect(() => {
    dispatch(verifyJwt());
  }, []);

  useEffect(() => {
    if (signup?.isSuccess && identity && signup?.plan) {
      const { plan } = signup;
      const event = generateSubscriptionAPIGTMEvent({ identity, plan });
      pushGTMEvent(event);
    }
  }, [identity, signup, dispatch]);

  return isAuthenticated ? <Navigate replace to="/" /> : page;
};

export default PublicRoute;
